import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval } from 'rxjs/internal/observable/interval';
import { Subscription } from 'rxjs/internal/Subscription';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { MonedoService } from 'src/app/core/services/monedo.service';
import { FinzyModule } from '../finzy.module';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'f-app-kyc',
  templateUrl: './kyc.component.html',
  styleUrl: './kyc.component.scss'
})
export class KycComponent implements OnInit {
  kycForm: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder, private finzyService: FinzyService, private sanitizer: DomSanitizer, private router: Router, private spinner: NgxSpinnerService, private route: ActivatedRoute) {
    this.kycForm = formBuilder.group({
      aadhaarNumber: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{12}$')],
      ]
    });
  }
  async ngOnInit() {
    this.spinner.hide();

    this.route.queryParamMap.subscribe(async params => {
      const status = params.get('status');
      const transId = params.get('unifiedtransactionid');

      if (status === 'success' && transId) {
        this.spinner.show();
        try {
          var res = await lastValueFrom(this.finzyService.UpdateKYC({ status: status, transactionId: transId }));
          if (res['data'] === "success") {
            return this.router.navigateByUrl('/assist-journey/f/account-aggregator');
          }
        } catch (err) {
          if (err?.status === 401) {
            this.spinner.hide();
            this.router.navigateByUrl('/assist-journey/session-expired');
          }
        }
      }
    });

  }

  onSubmit() {
    if (this.kycForm.valid) {
      this.spinner.show();
      try {
        this.finzyService.InitiateKYC({ userInfo: { aadhaarNumber: this.kycForm.value.aadhaarNumber } }).subscribe(response => {
          if (response['data'] != null) {
            this.spinner.hide();
            window.location.href = response['data'];
          }
          else {
            swal.fire('Error', 'Error initiating KYC. Please try again later.');
          }
        });
      } catch (err) {
        if (err.status === 0) {
          swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
          this.spinner.hide();
          return;
        }

        if (err?.status === 401) {
          this.spinner.hide();
          this.router.navigateByUrl('/assist-journey/session-expired');
        }

        swal.fire('Error', 'Error initiating KYC. Please try again later.');
      }
      this.spinner.hide();
    }
    else {
      swal.fire('Error', 'Please enter a valid Aadhaar Number.');
    }

  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  get m() {
    return this.kycForm.controls;
  }
}
